import { createContext, useContext, useState, useEffect } from 'react';
import { workflowApi } from '../services/api.js';

const ConfigurationContext = createContext();

export function ConfigurationProvider({ children }) {
  const [systemConfig, setSystemConfig] = useState({});
  const [workflowConfigs, setWorkflowConfigs] = useState({});
  const [loading, setLoading] = useState(true);
  const CONFIG_ID = '69b8f3fa-6808-45ea-8b04-f8b80b66772b';

  const fetchSystemConfiguration = async () => {
    try {
      const response = await workflowApi.getSystemConfiguration(CONFIG_ID);
      setSystemConfig(response.data.value || {});
    } catch (error) {
      console.error('Failed to fetch system configuration:', error);
      setSystemConfig({});
    }
  };

  const fetchWorkflowConfiguration = async (workflowId) => {
    try {
      const response = await workflowApi.getWorkflowConfiguration(CONFIG_ID, workflowId);
      setWorkflowConfigs(prev => ({
        ...prev,
        [workflowId]: response.data || {}
      }));
      return response.data || {};
    } catch (error) {
      console.error('Failed to fetch workflow configuration:', error);
      return {};
    }
  };

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      await fetchSystemConfiguration();
      setLoading(false);
    };
    init();
  }, []);

  return (
    <ConfigurationContext.Provider value={{
      systemConfig,
      workflowConfigs,
      loading,
      refreshSystemConfig: fetchSystemConfiguration,
      fetchWorkflowConfig: fetchWorkflowConfiguration
    }}>
      {children}
    </ConfigurationContext.Provider>
  );
}

export function useConfiguration() {
  const context = useContext(ConfigurationContext);
  if (!context) {
    throw new Error('useConfiguration must be used within a ConfigurationProvider');
  }
  return context;
} 